import React from "react";
import { UserPayoutEventListContentCellTemplate } from "themes/administration/analytics/components";

function UserPayoutEventListContentCell(props) {
    return <UserPayoutEventListContentCellTemplate {...props} />;
}

export default UserPayoutEventListContentCell;
